import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './components/ui';
import ErrorBoundary from './components/ErrorBoundary';
import { sledujChyby } from './chyby';
import './index.css';

/* Chyby mimo vykresľovania (kliknutia, načítanie údajov) poistka nezachytí –
 * počúva ich toto. */
sledujChyby();

/* ── Aby sa to dalo na telefóne pridať na plochu ────────────────────────────
 *
 * Service worker sám o sebe nič neukladá (prečo, je napísané v `public/sw.js`)
 * – je tu preto, že bez neho prehliadač inštaláciu na plochu neponúkne.
 *
 * `updateViaCache: 'none'` znamená, že sa samotný súbor service workera nikdy
 * neberie zo zásoby prehliadača. Bez toho by po aktualizácii systému mohol
 * ešte deň bežať ten starý.
 *
 * Registrácia je zámerne až po načítaní stránky a chyba sa len zapíše:
 * v nezabezpečenom pripojení (http na sieti v predajni) service worker
 * nefunguje a systém sa preto nemá čo zastaviť. */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .catch((e) => console.warn('Service worker sa nezaregistroval:', e.message));
  });
}

/* Poistka je aj tu, nielen okolo stránok: keby spadlo samotné rozloženie
 * (menu, hlavička), vnútorná poistka by sa k slovu nedostala a ostala by
 * prázdna plocha. */
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
